import { EventsApiResponse } from "./types";

export const initialAllEventState: EventsApiResponse = {
  results: [],
  count: 0,
  next: null,
  previous: null,
};
